import spartaSingletonUtility from '@sparta.global.utilities/sparta-singleton-utility/dist/es6.js';

/* global spaParams */

/**
 * @name        Benchmark Utility
 * @file        benchmark-utility.js
 * @description Sets console timers to module methods to report how long methods took
 * @classdesc   Sets console timers to module methods to report how long methods took
 * @global      Creates a global BenchmarkUtility object
 */

const allowedEnvs = ['local', 'dev1', 'dev2', 'dev3', 'dev4', 'dev5', 'devflex'];
const allowedEnv = allowedEnvs.indexOf(spaParams.siteParams.env) >= 0;

/**
 * BenchmarkUtility Class
 */
class BenchmarkUtility {
  /**
   * Creates an instance of mastheadContainerModuleJS
   */
  constructor() {
    this.records = [];
    this.bindWindowFunction();
  }

  /**
   * Creates an instance of mastheadContainerModuleJS
   * @param {object} instance instance options
   * @returns {void}
   */
  init(instance) {
    // eslint-disable-line
    try {
      if (!allowedEnv) return;
      const classFn = Object.getPrototypeOf(instance).constructor;

      // Static methods
      Object.getOwnPropertyNames(classFn).forEach(name => {
        const method = classFn[name];
        if (method instanceof Function) {
          classFn[name] = (...args) => {
            const start = performance.now();
            const returnVal = method.apply(classFn, args);
            const end = performance.now();
            this.records.push({
              name: `${classFn.name}::${name}`,
              ms: end - start
            });
            return returnVal;
          };
        }
      });

      // Instance methods
      Object.getOwnPropertyNames(Object.getPrototypeOf(instance)).forEach(name => {
        const method = instance[name];
        if (method instanceof Function) {
          instance[name] = (...args) => {
            // eslint-disable-line
            const start = performance.now();
            const returnVal = method.apply(instance, args);
            const end = performance.now();
            this.records.push({
              name: `${classFn.name}.${name}`,
              ms: end - start
            });
            return returnVal;
          };
        }
      });
    } catch (e) {
      console.error(e);
    }
  }

  /**
   * @returns {void}
   */
  bindWindowFunction() {
    if (!allowedEnv) return;
    if (typeof window.benchmark !== 'undefined') return;
    window.benchmark = this.results.bind(this);
  }

  /**
   * @returns {void}
   */
  results() {
    if (!this.records.length) {
      // eslint-disable-next-line
      console.log('%cNo records to display. Reload or trigger events to populate.', 'background: green; color: white; padding: 3px 7px; font-weight: strong;');
      return;
    }
    console.table(this.records); // eslint-disable-line
    let totalMs = 0;
    this.records.forEach(record => {
      totalMs += record.ms;
    });
    let bgColor = 'green';
    let textColor = 'white';
    let emoji = '👍';
    if (totalMs >= 500) {
      bgColor = 'red';
      emoji = '😱';
    } else if (totalMs >= 400 && totalMs < 500) {
      bgColor = 'orange';
      emoji = '🤔';
    } else if (totalMs >= 250 && totalMs < 400) {
      bgColor = 'yellow';
      textColor = 'black';
      emoji = '😕';
    }

    // eslint-disable-next-line
    console.log(`%c${emoji} Total Time: ${totalMs}ms`, `background: ${bgColor}; color: ${textColor}; padding: 3px 7px; font-weight: strong;`);
    this.records = [];
  }
}

/**
 * @const benchmarkUtility
 * @description single instance of BenchmarkUtility used to expose this utility
 */
const benchmarkUtility = spartaSingletonUtility('sparta.utility.benchmarkUtility', BenchmarkUtility);

export { benchmarkUtility as default };
